module.exports = __webpack_public_path__ + "static/media/img.4a296f28.jpeg";